var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerTechnician(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.31,
    height: 33.999,
    viewBox: "0 0 34.31 33.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dealer_technician") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7a7b7d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-86.68 -57.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.939,85.12l.839-.5V83.557l-.839-.457-.839.457v1.105Z",
    transform: "translate(35.326 3.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.914,53.089c-.419-1.22-1.563-1.677-2.744-2.1v3.964a1.863,1.863,0,0,1-1.829,1.868,1.9,1.9,0,0,1-1.334-.534,1.815,1.815,0,0,1-.534-1.3l-.038-5.45c-1.906-.762-4.078-1.6-4.383-1.677a8.5,8.5,0,0,1-1.486-2.4c-.3-.038-.61-.076-.953-.152.038-1.029.686-1.105.953-1.868.229-.686.038-1.6.381-2.249.229-.457.572-.229.839-.61a4.085,4.085,0,0,0,.381-1.525c.152-.762.229-1.677.343-2.516a.624.624,0,0,0-.381-.648H15.207s-.419.114-.343.953c.076.953.076,3.316,1.029,3.85.648.381.648,1.906.991,2.973.267.915.953.648,1.143,1.525l-.877.191a6.408,6.408,0,0,1-1.486,2.4c-.5.152-5.107,1.944-6.861,2.668-1.563.648-3.468.915-4.04,2.554,0,1.105-.114,3.773-.076,5.222h34.3C38.99,56.863,38.914,54.195,38.914,53.089Z",
    transform: "translate(82 32.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.1,14.828H42.8V13.571a7.244,7.244,0,0,0-6.556-7.432c-.076-.5-.343-.839-.61-.839-.3,0-.534.343-.61.839A7.25,7.25,0,0,0,28.4,13.571v1.22H27.1v1.3h17Z",
    transform: "translate(68.125 51.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M77.606,49.632l-.038-8.995v-.114a3.988,3.988,0,0,0,1.982-3.43A3.879,3.879,0,0,0,77.567,33.7v3.163l-1.944,1.143-1.982-1.143V33.7A3.831,3.831,0,0,0,71.7,37.13a3.921,3.921,0,0,0,2.172,3.506h0l.038,7.508c.953.381,1.868.762,2.439.991A8.6,8.6,0,0,0,77.606,49.632Z",
    transform: "translate(40.526 34.208)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerTechnician);
export default __webpack_public_path__ + "static/media/dealer_technician.4102f220035053523b3ff932a275f808.svg";
export { ForwardRef as ReactComponent };